import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../../../index";  // ✅ Подключаем контекст

const SocialLogin = ({ onAuthSuccess, onAuthError, onClose }) => {
  const navigate = useNavigate();
  const { user } = useContext(Context);  // ✅ Теперь `user` доступен в компоненте

  useEffect(() => {
    const container = document.getElementById("telegram-widget-container");
    if (container) container.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", "aut_boost_bot");
    script.setAttribute("data-size", "large");
    script.setAttribute("data-request-access", "write");
    script.setAttribute("data-onauth", "handleTelegramAuth(user)");  // ⚠️ Передаем `user`

    if (container) container.appendChild(script);

    // ✅ Локальная функция для обработки Telegram-авторизации
    const handleTelegramAuth = async (tgUserData) => {
      try {
        console.log("📩 Данные пользователя из Telegram:", tgUserData);

        const response = await fetch("https://boost-ai.ru/api/auth/telegram/callback", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",  // ✅ ОБЯЗАТЕЛЬНО для кук сессии
          body: JSON.stringify(tgUserData),
        });

        console.log("🔄 Сервер ответил:", response);

        if (!response.ok) {
          console.warn(`❌ Ошибка HTTP ${response.status}: ${response.statusText}`);
          const errorText = await response.text();
          console.warn("❌ Ответ сервера (text):", errorText);
          return;
        }

        const data = await response.json();
        console.log("✅ JSON-данные сервера:", data);

        if (!data.user) {
          console.error("❌ Ошибка: В ответе нет `user`!", data);
          return;
        }

        // ✅ Сохраняем пользователя в MobX
        user.setIsAuth(true);
        user.setUser(data.user);
        onClose(); // Закрываем форму после успешного входа
        // ✅ Проверяем, что теперь курсы подтягиваются
        console.log("📚 Купленные курсы:", user.purchased_courses);

        // ✅ Сохраняем пользователя в localStorage
        localStorage.setItem("user", JSON.stringify(data.user));

        console.log("✅ Успешная авторизация:", data);

        // ✅ Редиректим пользователя
        navigate(user.userHomePath);

      } catch (error) {
        console.error("❌ Ошибка авторизации через Telegram:", error);
      }
    };

    window.handleTelegramAuth = handleTelegramAuth;

    return () => {
      delete window.handleTelegramAuth;
      if (container) container.innerHTML = "";
    };
  }, [navigate, user]);  // ✅ Добавляем `user` в зависимости

  return (
    <div className="social-login">
      <div id="telegram-widget-container"></div>
    </div>
  );
};

SocialLogin.propTypes = {
  onAuthSuccess: PropTypes.func.isRequired,
  onAuthError: PropTypes.func.isRequired,
};

export default SocialLogin;
